import type * as ents from '@attain-apps/entities'

/**
 * Returns unique dataset names from chart points or slices
 */
export function getUniqueDatasetNames(
  values:
    | readonly ents.core.display.chart.data.Point.Group[]
    | readonly ents.core.display.chart.data.Slice[],
): Set<string> {
  return values.reduce((set, { name }) => {
    set.add(name ?? '')
    return set
  }, new Set<string>())
}
